import { contextualizeArticle } from '../models';
export var articlesLayers = [{
  id: 'Article',
  type: 'view',
  action: 'article',
  name: 'article',
  event: true,
  contextualize: function contextualize(_ref) {
    var article = _ref.article;
    return contextualizeArticle(article);
  }
}];